module.exports = __webpack_public_path__ + "img/banner.ccbad61b.jpg";